import { reactive } from 'vue';

function prepareAnimationObject(sender, items, item, initState) {
	// Wrap the entire item in reactive proxy to ensure all property changes are tracked
	const reactiveItem = reactive({
		...item,
		__classes: {
			show: initState === 'show',
			hide: initState === 'hide',
			showing: false,
			hiding: false,
			selected: false
		},
		__styles: {
			'--animationTime': '750ms',
			'--animationDelay': '0ms'
		}
	});

	const animate = async (state, time, delay) => {
		switch (state) {
			case 'deselect':
				items.forEach(f => {
					if (f.__classes) f.__classes.selected = false;
				});
				if (items.__classes) items.__classes['has-selected'] = false;
				break;
			case 'select':
				items.forEach(f => {
					if (f.__classes) f.__classes.selected = false;
				});
				reactiveItem.__classes.selected = true;
				if (items.__classes) items.__classes['has-selected'] = true;
				break;
			default:
				reactiveItem.__classes.showing = state === 'show';
				reactiveItem.__classes.hiding = state === 'hide';
				reactiveItem.__styles['--animationTime'] = `${time}ms`;
				reactiveItem.__styles['--animationDelay'] = `${delay}ms`;
				reactiveItem.__classes.show = state === 'show';
				reactiveItem.__classes.hide = state === 'hide';
				await new Promise(res => setTimeout(res, time + delay));
				break;
		}
	}

	reactiveItem.animate = animate;

	return reactiveItem;
}

function prepareAnimationObjects(sender, items, initState) {
	initState = initState || 'show';
	
	// Create reactive array - will be populated with reactive items
	const reactiveItems = [];
	
	// Create all reactive items and pass the reactive array reference
	// Each item's animate function will close over this array
	items?.forEach(f => {
		reactiveItems.push(prepareAnimationObject(sender, reactiveItems, f, initState));
	});
	
	// Add __classes as reactive property to the array itself
	reactiveItems.__classes = reactive({
		'has-selected': false
	});

	const animate = async (state, time, animateItems) => {
		time = time || 750;

		animateItems = animateItems || reactiveItems;

		let interval = time / animateItems?.length;

		let currentTime = 0;
		animateItems?.forEach(f => {
			f.animate(state, interval, currentTime);
			currentTime += interval / 2;
		});

		await new Promise(res => setTimeout(res, currentTime + interval));
	}

	reactiveItems.animate = animate;

	return reactiveItems;
}

export default {
	prepareAnimationObject,
	prepareAnimationObjects
}